import React, { useMemo } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { getLogVersion } from '@bingads-webui-campaign-react/asset-library-model';

import { getLogger } from './logger';

export function withCustomLogForPage(WrappedComponent, { pageName, tag = 'Asset library' }) {
  const Wrapper = (props) => {
    const { activity, permissions } = props || {};
    const version = useMemo(() => getLogVersion(permissions), [permissions]);

    const logger = useMemo(() => getLogger(activity, pageName, version, tag), [activity, version]);

    return <WrappedComponent {...props} logger={logger} />;
  };

  Wrapper.displayName = `withCustomLog(${getDisplayName(WrappedComponent)})`;
  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
}

export const getLoggerWithoutPageInfo = (activity, version, tag = 'Asset library') => getLogger(activity, '', version, tag);
